import { createApp } from "vue";
import { createPinia } from "pinia";
import { VueFire, VueFireFirestoreOptionsAPI } from "vuefire";
import App from "./App.vue";
import router from "./router";
import moment from "moment";
import VueGtag from "vue-gtag";
import { createBootstrap } from "bootstrap-vue-next";

import "@/common/styles/members-custom-vars.scss";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { markRaw } from "vue"; // Import markRaw to prevent reactivity on certain objects
import { app, db, firebaseConfig, storage } from "@/lib/localFirebase";
import { FontAwesomeIcon, initFontAwesome } from "@/lib/fontAwesome";

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

initFontAwesome();

// const analytics = getAnalytics(app);
window.db = markRaw(db); // Prevent db from being made reactive
window.storage = markRaw(storage); // Prevent storage from being made reactive

const pinia = createPinia();
const vueApp = createApp(App);

// https://matteo-gabriele.gitbook.io/vue-gtag/auto-tracking
vueApp.use(VueGtag, { config: { id: "G-PX5FKD9PFT" } }, router);

vueApp.config.globalProperties = {
  $moment: moment,
  answer: 42,
};

vueApp.component("font-awesome-icon", FontAwesomeIcon);

vueApp.use(router);
vueApp.use(pinia);
vueApp.use(createBootstrap());
// https://vuefire.vuejs.org/guide/getting-started.html
vueApp.use(VueFire, {
  // imported above but could also just be created here
  app,
  modules: [
    // we will see other modules later on
    // VueFireAuth(), // ERROR: Cannot Read Container!???
    VueFireFirestoreOptionsAPI(),
  ],
});

vueApp.mount("#app");

export { firebaseConfig, app, vueApp, db }; // Export firebaseConfig as well
